/**
 * MbrasAtrzRtso.tsx
 * ------------------------------------------------------------
 * 조합원 "결재 상신" 화면
 */

import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import Modal from "@/js/common/ui/modal/Modal";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import MbrasNewHistory from "../atrz/history/MbrasNewHistory";
import MbrasWhdwlHistory from "../atrz/history/MbrasWhdwlHistory";
import MbrasRegulHistory from "../atrz/history/MbrasRegulHistory";
import MbrasDepartHistory from "../atrz/history/MbrasDepartHistory";
import MbrasLeaveHistory from "../atrz/history/MbrasLeaveHistory";
import MbrasLeaveExtendHistory from "../atrz/history/MbrasLeaveExtendHistory";
import MbrasReturnHistory from "../atrz/history/MbrasReturnHistory";
import MbrasResignHistory from "../atrz/history/MbrasResignHistory";
import MbrasRetireHistory from "../atrz/history/MbrasRetireHistory";
import MbrasRejoinHistory from "../atrz/history/MbrasRejoinHistory";
import DialogTitleBar from "../../common/DialogTitleBar";
import * as Atom from "@/js/common/Atom";
import { useRecoilValue } from "recoil";

const MbrasAtrzRtso = () => {
    const userInfo = useRecoilValue(Atom.userInfo);


  const [keyword, setKeyword] = React.useState("");
  const [mbrasAtrzSeCd, setMbrasAtrzSeCd] = React.useState("");
  const [upOgnzCd,    _setUpOgnzCd] = React.useState<string>(userInfo.upOgnzCd); // 상위조직코드(본부)
  const [ognzCd,      _setOgnzCd] = React.useState<string>(userInfo.ognzCd); // 조직코드(지부)
  const [ocptTypeCd, setOcptTypeCd] = React.useState("");
  const [sttDt, setSttDt] = React.useState("");
  const [endDt, setEndDt] = React.useState("");

  const [dataArr, setDataArr] = React.useState<[]>([]);
  const [checkDataArr, setCheckDataArr] = React.useState<any[]>([]);

  const [modalOpen, setModalOpen] = React.useState(false);
  const [mbrasAtrzDocId, setMbrasAtrzDocId] = React.useState<string>(""); // 조합원 결재 문서 ID
  const [mbrasId, setMbrasId] = React.useState<string>("");
  const [detailAtrzSeCd, setDetailAtrzSeCd] = React.useState<string>(""); // 결재문서 구분코드
  const [callTime, setCallTime] = React.useState<Date>(new Date());

  const fldInfs: fldInfsProps[] = [
    { type: "seq" ,                         width:  50, headAlign: "center", dataAlign: "center", label: "No." },
    { type: "text", fldNm: "mbrasId"       , width: 120, headAlign: "center", dataAlign: "center", label: "조합원번호" },
    { type: "text", fldNm: "mbrasNm"       , width:  90, headAlign: "center", dataAlign: "center", label: "성명" },
    { type: "el"  , fldNm: "mbrasAtrzSeCd", width: 100, headAlign: "center", dataAlign: "center", label: "구분", el: (item: any) => <span className={"ls06 " + (item.mbrasAtrzSeCd === "03" ? "fcE53935" : "")}>{Util.getValToCode("MBRAS_ATRZ_SE_CD", item.mbrasAtrzSeCd)}</span> },
    { type: "text", fldNm: "upOgnzNm"      , width: 120, headAlign: "center", dataAlign: "center", label: "본부" },
    { type: "text", fldNm: "ognzNm"        , width: 120, headAlign: "center", dataAlign: "center", label: "지부" },
    { type: "text", fldNm: "wtjrNm"        , width: 160, headAlign: "center", dataAlign: "center", label: "관내" },
    { type: "code", fldNm: "ocptTypeCd"    , width: 110, headAlign: "center", dataAlign: "center", label: "직종", catCode: "OCPT_TYPE_CD" },
    { type: "text", fldNm: "crtDt"         , width: 110, headAlign: "center", dataAlign: "center", label: "작성일자" },
  ];
  // 결재 상신 리스트 조회
  React.useEffect(() => {
    // 작성일자 검색 조건 확인
    if (Util.isNotEmpty(sttDt) && Util.isNotEmpty(endDt)) {
        if (sttDt > endDt) {
            AppContext.openAlert({ 
                title: "작성일자 검색 조건 확인", 
                msg: "작성일자의 검색 시작일자가 종료일자보다 느립니다.", 
                icon: "warning" 
            }); 
            setEndDt("")
            return;
        } 
    }
    AppContext.showSpinner();
    Axios.dataAccess({
      url: "system/mbra/atrzrtso/select-mbras-atrz-rtso-list.do",
      methodType: "post",
      paramType: "json",
      paramData: {
        // keyword       : keyword,
        mbrasAtrzSeCd : mbrasAtrzSeCd,
        upOgnzCd      : ognzCd === "00_000" ? "" : upOgnzCd,
        ognzCd        : ognzCd.includes("000") ? "" : ognzCd, // 지방본부(000): 해당 지방본부만
        ocptTypeCd    : ocptTypeCd,
        sttDt         : sttDt,
        endDt         : endDt,
      },
      onSuccessFn: (res: any) => {
        setDataArr(res.result.list);
        AppContext.hideSpinner();
      },
    });
  }, [callTime, upOgnzCd, ognzCd, endDt, ocptTypeCd, mbrasAtrzSeCd, sttDt]);


    const doProcessMbrasAtrzRtso = () => {
      if ((checkDataArr?.length ?? 0) === 0) {
        AppContext.openAlert({ title: "알림", msg: "결재 상신할 조합원을 선택해주세요." });
        return;
      }
      AppContext.openAlert({
        title: "확인",
        msg: "결재상신을 진행하시겠습니까?",
        icon: "question",
        closeText: "취소",
        confirmText: "결재상신",
        handleConfirm: () => {
            AppContext.showSpinner();
            Axios.dataAccess({
              url: "system/mbra/atrzrtso/process-mbras-atrz-rtso-new.do",
              methodType: "post",
              paramType: "json",
              paramData: { dataList: checkDataArr },
              onSuccessFn: () => {
                AppContext.openAlert({ title: "알림", msg: "결재 상신이 완료되었습니다." });
                setCheckDataArr([]);
                setCallTime(new Date());
                AppContext.hideSpinner();
              },
            });
          },
      });
    }

  return (
    <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
      <div className="mt5">
        <span className="posR dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">조합원 결재 상신</span>
        <div className="bdt3 bdc007bff pb10"></div>
      </div>

      <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
        <div className="dpFlx aiC gap14">
          <div className="dpFlx aiC">
            <span className="w40 fm-c fs15 fc333333 ls1 taL">성명</span>
            <TextBox
              value={keyword}
              width={120}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              style={{ backgroundColor: "#fff", padding: "0 10px" }}
              placeholder="성명 입력"
              onChangeFunc={(text: string) => setKeyword(text)}
            />
          </div>

          <div className="dpFlx aiC">
            <span className="w40 fm-c fs15 fc333333 ls1 taL ">구분</span>
            <SelectBox
              value={mbrasAtrzSeCd}
              width={100}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              background="#fff"
              codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("UI_MBRAS_ATRZ_SE_CD_01"))}
              placeholder="전체"
              paddingRight={8}
              onChangeFunc={(data: string) => setMbrasAtrzSeCd(data)}
            />
          </div>

          <div className="dpFlx aiC">
            <span className="w40 fm-c fs15 fc333333 ls1 taL">직종</span>
            <SelectBox
              value={ocptTypeCd}
              width={150}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              background="#fff"
              codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("OCPT_TYPE_CD"))}
              placeholder="전체"
              paddingRight={8}
              onChangeFunc={(data: string) => setOcptTypeCd(data)}
            />
          </div>

          <div className="dpFlx aiC">
            <span className="w70 fm-c fs15 fc333333 ls1 taL">작성일자</span>
            <DatePickerBox
              width={150}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              bgColor="white"
              textAlign="left"
              calendarThemeColor={AppContext.themeColor}
              className="mr5"
              value={sttDt}
              onChange={(data: string) => setSttDt(data)}
            />
            <span className="fm-c fc666666 mr5">~</span>
            <DatePickerBox
              width={150}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              bgColor="white"
              textAlign="left"
              calendarThemeColor={AppContext.themeColor}
              className="mr5"
              value={endDt}
              onChange={(data: string) => setEndDt(data)}
            />
          </div>

          <div className="dpFlx aiC mlA">
            <Button
              width={75}
              height={40}
              fontFamily="fm-b"
              fontSize={16}
              letterSpacing={-1}
              variant="styInitBtn"
              borderRadius={6}
              buttonClass="dpFlx aiC jcC"
              buttonName="초기화"
              onClickFunc={() => {
                setKeyword("");
                setMbrasAtrzSeCd("");
                setOcptTypeCd("");
                setSttDt("");
                setEndDt("");
              }}
            />
          </div>
        </div>
      </div>

      <div className="dpFlx aiC jcSb mb10 h44">
        <div className="fm-b fs16 fc007bff ls1 fw700">
          <span>조합원 목록</span>
        </div>

        <Button
          width={150}
          height={40}
          fontFamily="fm-b"
          fontSize={16}
          letterSpacing={-1}
          variant="styCompleteBtn"
          borderRadius={6}
          buttonClass="dpFlx aiC jcC"
          buttonName="결재 상신"
          onClickFunc={doProcessMbrasAtrzRtso}
        />
      </div>

      <GridTable
        tableInfo={
          {
            tableHeadVsb: true,
            styleType: AdminGridStyle,
            fldInfs,
            ordFld: { name: "mbrasId", direction: "desc" },
            dataArr: Util.filterFieldData(dataArr as any, fldInfs, "mbrasNm", keyword),
            maxRowNums: [10, 20, 30],
            theadTrHeight: 40,
            tbodyTrHeight: 35,
            paginateClass: "pt10",
            paginateStyle: {
              buttonOnColor: AppContext.boardThemeColor,
              buttonWidth: 22,
              buttonHeight: 24,
              buttonMarginLeft: 1,
              buttonMarginRight: 1,
              fontSize: 13,
              color: "#666666",
              letterSpacing: -0.8,
              fontFamily: "Pretendard-Regular",
              borderRadius: 3,
            },
            footerVsb: true,
            checkedHookParam: {
              checkDataArr: checkDataArr,
              setCheckDataArr: setCheckDataArr,
            },
            rowClickFunc: (row: any) => {
                setMbrasId(row.mbrasId);
                setMbrasAtrzDocId(row.mbrasAtrzDocId);
                setDetailAtrzSeCd(row.mbrasAtrzSeCd);
                setModalOpen(true);
            },
          } as any
        }
      />

      <Modal
        modalOpen={modalOpen}
        dim={true}
        visible={true}
        width={760}
        titleEl={<DialogTitleBar title={"조합원 상세"} backgroundColor={AppContext.themeColor} />}
        onCloseFunc={() => {
          setMbrasId("");
          setMbrasAtrzDocId("");
          setDetailAtrzSeCd("");
          setModalOpen(false);
        }}
      >
        <div className="h900">
            {detailAtrzSeCd === "01" && (
                <MbrasNewHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}

            {detailAtrzSeCd === "03" && (
                <MbrasWhdwlHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}

            {detailAtrzSeCd === "04" && (
                <MbrasRegulHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}

            {detailAtrzSeCd === "05" && (
                <MbrasDepartHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}

            {detailAtrzSeCd === "06" && (
                <MbrasLeaveHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}

            {detailAtrzSeCd === "07" && (
                <MbrasLeaveExtendHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}

            {detailAtrzSeCd === "08" && (
                <MbrasReturnHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}

            {detailAtrzSeCd === "09" && (
                <MbrasResignHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}

            {detailAtrzSeCd === "10" && (
                <MbrasRetireHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}

            {detailAtrzSeCd === "11" && (
                <MbrasRejoinHistory
                    mbrasId={mbrasId}
                    mbrasAtrzDocId={mbrasAtrzDocId}
                    showAtrzLine={false}
                />
            )}
            {/* 닫기 버튼 */}
            <div className="dpFlx jcC mt25 mb10 gap10">
                <Button
                    width={100}
                    height={40}
                    fontFamily="fm-b"
                    fontSize={16}
                    letterSpacing={-1}
                    variant="styCloseBtn"
                    borderRadius={6}
                    buttonClass="dpFlx aiC jcC"
                    buttonName="닫기"
                    onClickFunc={() => {
                        setMbrasId("");
                        setMbrasAtrzDocId("");
                        setDetailAtrzSeCd("");
                        setModalOpen(false);
                    }}
                />
            </div>
        </div>
      </Modal>

    </div>
  );
};

export default MbrasAtrzRtso;